import React, { useEffect, useState } from 'react';
import Layout from "../layout/Layout";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import CustomPagination from "../components/CustomPagination";
import CustomFormInput from "../components/CustomFormInput";
import DeleteModal from '../components/DeleteModal';
import AddSkillModal from '../components/EventManagement/AddSkillModal';
import { Link, useLocation } from 'react-router-dom';
import ScrollingTab from '../components/ScrollingTab';
import { Nav, Tab } from 'react-bootstrap';
import { requestHandler } from '../helper';
import { deleteActivityList, deleteCategoryList, deleteEvent, deleteSkill, getActivityList, getAllActivityList, getAllSkill, getCategoryList, getEventData, getSkill } from '../controller';
import Loader from '../components/Loader';
import { formatDate } from '../helper/common';
import { toast } from 'react-toastify';
import EventViewModal from '../components/EventManagement/EventViewModal';
import AddActivityModal from '../components/EventManagement/AddActivityModel';
import AddCategoryModal from '../components/EventManagement/AddCategory';

function EventManagement() {

  const [show, setShow] = useState(false);
  const [viewShow, setViewShow] = useState(false);
  const [showAddSkill, setAddSkill] = useState(false);
  const [showActivity, setShowActivity] = useState(false);
  const [showCat, setShowCat] = useState(false);
  const [skill, setSkillData] = useState([]);
  const [skills, setSkills] = useState([]);
  const [activities, setActivities] = useState([]);
  const [activity, setActivityData] = useState([]);
  const [category, setCategoryData] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState({});
  const [selectedActivity, setSelectedActivity] = useState({});
  const [selectedEvent, setSelectedEvent] = useState({});
  const [selectedCat, setSelectedCat] = useState({});
  const [activeTab, setActiveTab] = useState("flaggedSkill");
  const [loading, setLoading] = useState(true);
  const [eventData, setEventData] = useState([]);

  const [id, setId] = useState();
  const location = useLocation();

  const title = activeTab === "flaggedEvent" ? "Delete Event" : "Event Skill";
  const message = activeTab === "flaggedEvent" ? "Are you sure you want to delete this event?" : "Are you sure you want to delete this event skill?";
  const [search, setSearch] = useState("");

  // for event
  const [paginationValue, setPaginationValue] = useState({
    page: 1,
    limit: 10,
    totalData: 0,
    totalPages: 0
  })

  //skill
  const [paginationSkillValue, setPaginationSkillValue] = useState({
    page: 1,
    limit: 10,
    totalData: 0,
    totalPages: 0
  });

  //activity
  const [paginationActivityValue, setPaginationActivityValue] = useState({
    page: 1,
    limit: 10,
    totalData: 0,
    totalPages: 0
  });

  //category
  const [paginationCatValue, setPaginationCatValue] = useState({
    page: 1,
    limit: 10,
    totalData: 0,
    totalPages: 0
  })

  const { page, limit, totalData, totalPages } = paginationValue
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, totalData);


  const skillStart = (paginationSkillValue.page - 1) * paginationSkillValue.limit + 1;
  const skillEnd = Math.min(paginationSkillValue.page * paginationSkillValue.limit, paginationSkillValue.totalData);
  const skillTotalData = paginationSkillValue.totalData;

  const activityStart = (paginationActivityValue.page - 1) * paginationActivityValue.limit + 1;
  const activityEnd = Math.min(paginationActivityValue.page * paginationActivityValue.limit, paginationActivityValue.totalData);
  const activityTotalData = paginationActivityValue.totalData;

  const catStart = (paginationCatValue.page - 1) * paginationCatValue.limit + 1;
  const catEnd = Math.min(paginationCatValue.page * paginationCatValue.limit, paginationCatValue.totalData);
  const catTotalData = paginationCatValue.totalData;


  const handleAddSkillShow = () => setAddSkill(true);
  const handleAddActivityShow = () => setShowActivity(true);
  const handleAddCatShow = () => setShowCat(true);

  const handleEditSkill = (skill) => {
    setAddSkill(true); // Open modal
    setId(skill._id);
    setSelectedSkill(skill); // Pass existing skill data
  };

  const handleEditActivity = (activity) => {
    setShowActivity(true); // Open modal
    setId(activity._id);
    setSelectedActivity(activity);
  }

  const handleEditCategory = (category) => {
    setShowCat(true); // Open modal
    setId(category._id);
    setSelectedCat(category);
  }
  const handleViewClose = () => {
    setViewShow(false);
    setSelectedEvent(null);
  }

  const handleViewShow = (user) => {
    setSelectedEvent(user);
    setViewShow(true);
  }


  const getSkillData = async (page = 1) => {
    await requestHandler(
      async () => await getSkill(paginationSkillValue.limit, page),
      setLoading,
      (res) => {
        const { data, limit, page, totalData, totalPages } = res.data;
        setSkillData(data);
        setPaginationSkillValue({
          page,
          limit,
          totalData,
          totalPages
        })
      },
      () => { }
    )
  }

  const getSkillAllData = async () => {
    await requestHandler(
      async () => await getAllSkill(),
      setLoading,
      (res) => {
        setSkills(res.data);
      },
      () => { }
    )
  }

  const getAllActivityData = async () => {
    await requestHandler(
      async () => await getAllActivityList(),
      setLoading,
      (res) => {
        setActivities(res.data);
      },
      () => { }
    )
  }

  const getActivityData = async (page = 1) => {
    await requestHandler(
      async () => await getActivityList(paginationActivityValue.limit, page, search),
      setLoading,
      (res) => {
        const { data, limit, page, totalData, totalPages } = res.data;
        setActivityData(data);
        setPaginationActivityValue({
          page,
          limit,
          totalData,
          totalPages
        })
      },
      () => { }
    );
  }

  const getCategoryData = async (page = 1) => {
    await requestHandler(
      async () => await getCategoryList(paginationCatValue.limit, page, search),
      setLoading,
      (res) => {
        const { data, limit, page, totalData, totalPages } = res.data;
        setCategoryData(data);
        setPaginationCatValue({
          page,
          limit,
          totalData,
          totalPages
        })
      },
      () => { }
    );
  }

  const getEvent = async (page = 1) => {
    await requestHandler(
      async () => await getEventData(limit, page, search),
      setLoading,
      (res) => {
        const { data, limit, page, totalData, totalPages } = res.data;
        setEventData(data);
        setPaginationValue({
          page,
          limit,
          totalData,
          totalPages
        })
      },
      () => { }
    );
  }



  useEffect(() => {
    if (activeTab === "flaggedSkill") {
      getSkillAllData();
      getSkillData();
      getAllActivityData();
    }
    if (activeTab === "flaggedActivity") {
      getActivityData();
    }
    if (activeTab === "flaggedCategory") {
      getCategoryData();
    }

    // }
    if (activeTab === "flaggedEvent") {
      if (search) {
        const delayDebounce = setTimeout(() => {
          getEvent(1);
        }, 500);
        return () => clearTimeout(delayDebounce);
      } else {
        getEvent(1);
      }
    }

    // eslint-disable-next-line
  }, [activeTab, search, paginationValue.limit, paginationSkillValue.limit, paginationActivityValue.limit, paginationCatValue.limit]);


  const handleTabChange = (key) => {
    setActiveTab(key);
    localStorage.setItem("activeEventTab", key);
  };

  useEffect(() => {
    const tabFromLocation = location.state?.activeTab;
    const tabFromStorage = localStorage.getItem("activeEventTab");
    if (tabFromLocation) {
      setActiveTab(tabFromLocation);
      localStorage.setItem("activeEventTab", tabFromLocation);
    } else if (tabFromStorage) {
      setActiveTab(tabFromStorage);
    }

  }, [location.state?.activeTab]);

  const handleDeleteSkill = (skill) => {
    setSelectedSkill(skill);
    setShow(true);
  };



  const handleDeleteEvent = (event) => {
    setSelectedEvent(event);
    setShow(true);
  };

  const handleDeleteActivity = (activity) => {
    setSelectedActivity(activity);
    setShow(true);
  };

  const handleDeleteCategory = (category) => {
    setSelectedCat(category);
    setShow(true);
  }


  const deleteSkillList = async (skillId) => {
    await requestHandler(
      async () => await deleteSkill(skillId),
      setLoading,
      (res) => {
        toast.success(res.message);
        if (paginationSkillValue.totalData - 1 <= (paginationSkillValue.page - 1) * paginationSkillValue.limit) {
          getSkillData(1);
        } else {
          getSkillData(paginationSkillValue.page);
        }
        setShow(false);
      },
      () => { }
    );
  };

  const deleteActivity = async (activityId) => {
    await requestHandler(
      async () => await deleteActivityList(activityId),
      setLoading,
      (res) => {
        toast.success(res.message);

        if (paginationActivityValue.totalData - 1 <= (paginationActivityValue.page - 1) * paginationActivityValue.limit) {
          getActivityData(1);
        } else {
          getActivityData(paginationActivityValue.page);
        }
        setShow(false);
      },
      () => { }
    );
  };

  const deleteEventList = async (eventId) => {
    await requestHandler(
      async () => await deleteEvent(eventId),
      setLoading,
      (res) => {
        toast.success(res.message);
        if (paginationValue.totalData - 1 <= (paginationValue.page - 1) * paginationValue.limit) {
          getEvent(1);
        } else {
          getEvent(paginationValue.page);
        }
        setShow(false);
      },
      () => { }
    );
  };

  const deleteCategory = async (categoryId) => {
    await requestHandler(
      async () => await deleteCategoryList(categoryId),
      setLoading,
      (res) => {
        toast.success(res.message);
        if (paginationCatValue.totalData - 1 <= (paginationCatValue.page - 1) * paginationCatValue.limit) {
          getCategoryData(1);
        } else {
          getCategoryData(paginationCatValue.page);
        }
        setShow(false);
      },
      () => { }
    );
  }

  const handleDelete = () => {
    if (activeTab === "flaggedSkill") {
      deleteSkillList(selectedSkill._id);
      setSelectedSkill(null);
    } else if (activeTab === "flaggedEvent") {
      deleteEventList(selectedEvent._id);
      setSelectedEvent(null);
    }
    else if (activeTab === "flaggedCategory") {
      deleteCategory(selectedCat._id);
      setSelectedCat(null);
    }
    else if (activeTab === "flaggedActivity") {
      deleteActivity(selectedActivity._id);
      setSelectedActivity(null);
    }
  }

  const handleClose = () => {
    setShow(false);
    if (activeTab === "flaggedSkill") {
      setSelectedSkill(null);
    } else if (activeTab === "flaggedEvent") {
      setSelectedEvent(null);
    } else if (activeTab === "flaggedActivity") {
      setSelectedActivity(null);
    }
    else if (activeTab === "flaggedCategory") {
      setSelectedCat(null);
    }
  }

  const handlePageChange = (page, type) => {
    if (type === 'skill') {
      setPaginationSkillValue((prev) => ({
        ...prev,
        page,
      }));
      getSkillData(page); // Update the page when changing page for skill tab
    } else if (type === 'activity') {
      setPaginationActivityValue((prev) => ({
        ...prev,
        page,
      }));
      getActivityData(page); // Update the page when changing page for activity tab
    }
    else if (type === 'event') {
      setPaginationValue((prev) => ({
        ...prev,
        page,
      }));
      getEvent(page); // Update the page when changing page for event tab
    }
    else if (type === 'category') {
      setPaginationCatValue((prev) => ({
        ...prev,
        page,
      }));
      getCategoryData(page); // Update the page when changing page for category tab
    }
  };


  return (
    <>
      {loading && <Loader />}
      <Layout>
        <div className="card-wrapper">
          <div className="card-header border-bottom-0 pb-0">
            {activeTab === 'flaggedEvent' && (
              <div className='theme-select'>
                <Form.Select required name="limit" onChange={e => setPaginationValue({ ...paginationValue, [e.target.name]: e.target.value })}>
                  <option >10</option>
                  <option >15</option>
                  <option >20</option>
                </Form.Select>
              </div>
            )}
            <div className="d-flex align-items-center gap-2 flex-wrap">
              {activeTab === 'flaggedEvent' && (
                <div className="search-input">
                  <img src="/images/svg/search.svg" className="search-icon" alt="icon" />
                  <CustomFormInput
                    type="search"
                    placeholder="Search here..."
                    id="search"
                    value={search}
                    name='search'
                    onChange={(e) => setSearch(e.target.value)}
                    className="mb-0"
                  />
                </div>
              )}
              {activeTab === 'flaggedSkill' && (
                <button className='btn btn-outline-primary fs-16 fw-600' onClick={handleAddSkillShow}>+ Add Skill Levels</button>
              )}
              {activeTab === 'flaggedCategory' && (
                <button className='btn btn-outline-primary fs-16 fw-600' onClick={handleAddCatShow}>+ Add Category</button>
              )}
              {activeTab === 'flaggedActivity' && (
                <button className='btn btn-outline-primary fs-16 fw-600' onClick={handleAddActivityShow}>+ Add Activities Levels</button>
              )}
            </div>
          </div>
          <div className="card-body">
            <Tab.Container id="activityTab" activeKey={activeTab} onSelect={handleTabChange}>
              <ScrollingTab>
                <Nav className='theme-tab'>
                  {/* <Nav.Item>
                    <Nav.Link eventKey="flaggedEvent">Event</Nav.Link>
                  </Nav.Item> */}
                  <Nav.Item>
                    <Nav.Link eventKey="flaggedSkill">Skill</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="flaggedCategory">Categories</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="flaggedActivity">Activities</Nav.Link>
                  </Nav.Item>
                </Nav>
              </ScrollingTab>
              <Tab.Content className='mt-3'>
                {/* <Tab.Pane eventKey="flaggedEvent">
                  <div className='overflow-x-auto theme-scrollbar'>
                    <Table className="theme-table">
                      <thead>
                        <tr>
                          <th>Event Name</th>
                          <th>Organizer</th>
                          <th>Activities</th>
                          <th>Skill Level</th>
                          <th>Event Type</th>
                          <th>User Limit</th>
                          <th>Event Date & Time</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Boolean(eventData.length) ? eventData.map((event, index) => (
                          <tr key={index}>
                            <td>{event?.eventName}</td>
                            <td>{event?.userId?.firstName + " " + event?.userId?.lastName}</td>
                            <td >{event?.activities.map((activity) => activity.title).join(", ") || '-'}</td>
                            <td >{event?.skill.map((skill) => skill.name).join(", ") || '-'}</td>
                            <td>{event?.eventType === 0 ? "Private" : "Public"}</td>
                            <td>{event?.attendees?.length}/{event?.limit}</td>
                            <td>{formatDate(event?.eventDate)}</td>
                            <td width={175}>
                              <div className="d-flex align-items-center gap-2">
                                <button className="table-icon" onClick={() => handleViewShow(event)}>
                                  <img src="/images/svg/table-view.svg" alt="icon" />
                                </button>

                                <button className="table-icon border-danger-light" onClick={() => handleDeleteEvent(event)}>
                                  <img src="/images/svg/table-delete.svg" alt="icon" />
                                </button>

                                <Link to="/event-management/edit" className="table-icon border-primary-light" state={{ event: event, skill: skills, activity: activities }}>
                                  <img src="/images/svg/table-edit.svg" alt="icon" />
                                </Link>
                              </div>
                            </td>
                          </tr>
                        )) : (
                          <tr>
                            <td colSpan={10} className='text-center p-5 fs-5'>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap mt-1">
                    <p className="mb-0 fs-16 fw-500 text-light">     Showing {end === 0 ? 0 : start} to {end} of {totalData} entries</p>
                    {totalPages > 1 && (
                      <CustomPagination
                        currentPage={page}
                        totalPages={totalPages}
                        onPageChange={getEvent}
                      />
                    )}
                  </div>
                </Tab.Pane> */}
                <Tab.Pane eventKey="flaggedSkill">
                  <div className='overflow-x-auto theme-scrollbar'>
                    <Table className="theme-table">
                      <thead>
                        <tr>
                          <th>Skill Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Boolean(skill.length) ? skill.map((event, index) => (
                          <tr key={index}>
                            <td >{event.name}</td>
                            <td width={175}>
                              <div className="d-flex align-items-center gap-2">
                                <button className="table-icon border-danger-light" onClick={() => handleDeleteSkill(event)}>
                                  <img src="/images/svg/table-delete.svg" alt="icon" />
                                </button>
                                <button className="table-icon border-primary-light" onClick={() => handleEditSkill(event)}>
                                  <img src="/images/svg/table-edit.svg" alt="icon" />
                                </button>

                              </div>
                            </td>
                          </tr>
                        )) : (
                          <tr>
                            <td colSpan={10} className='text-center p-5 fs-5'>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap mt-1">
                    <p className="mb-0 fs-16 fw-500 text-light"> Showing {skillStart} to {skillEnd} of {skillTotalData} entries</p>
                    {paginationSkillValue.totalPages > 1 && (
                      <CustomPagination
                        currentPage={paginationSkillValue.page}
                        totalPages={paginationSkillValue.totalPages}
                        onPageChange={(page) => handlePageChange(page, 'skill')}
                      />
                    )}
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="flaggedCategory">
                  <div className='overflow-x-auto theme-scrollbar'>
                    <Table className="theme-table">
                      <thead>
                        <tr>
                          <th>Category Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Boolean(category.length) ? category.map((event, index) => (
                          <tr key={index}>
                            <td >{event.title}</td>
                            <td width={175}>
                              <div className="d-flex align-items-center gap-2">
                                <button className="table-icon border-danger-light" onClick={() => handleDeleteCategory(event)}>
                                  <img src="/images/svg/table-delete.svg" alt="icon" />
                                </button>

                                <button className="table-icon border-primary-light" onClick={() => handleEditCategory(event)}>
                                  <img src="/images/svg/table-edit.svg" alt="icon" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        )) : (
                          <tr>
                            <td colSpan={10} className='text-center p-5 fs-5'>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap mt-1">
                    <p className="mb-0 fs-16 fw-500 text-light">Showing {catStart} to {catEnd} of {catTotalData} entries</p>
                    {paginationCatValue.totalPages > 1 && (
                      <CustomPagination
                        currentPage={paginationCatValue.page}
                        totalPages={paginationCatValue.totalPages}
                        onPageChange={getCategoryData}
                      />
                    )}
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="flaggedActivity">
                  <div className='overflow-x-auto theme-scrollbar'>
                    <Table className="theme-table">
                      <thead>
                        <tr>
                          <th>Activity Name</th>
                          <th>Category Type</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Boolean(activity.length) ? activity.map((event, index) => (
                          <tr key={index}>
                            <td>{event.title}</td>
                            <td >{event.categoryId?.title}</td>
                            <td width={175}>
                              <div className="d-flex align-items-center gap-2">
                                <button className="table-icon border-danger-light" onClick={() => handleDeleteActivity(event)}>
                                  <img src="/images/svg/table-delete.svg" alt="icon" />
                                </button>

                                <button className="table-icon border-primary-light" onClick={() => handleEditActivity(event)}>
                                  <img src="/images/svg/table-edit.svg" alt="icon" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        )) : (
                          <tr>
                            <td colSpan={10} className='text-center p-5 fs-5'>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap mt-1">
                    <p className="mb-0 fs-16 fw-500 text-light">  Showing {activityStart} to {activityEnd} of {activityTotalData} entries</p>
                    {paginationActivityValue.totalPages > 1 && (
                      <CustomPagination
                        currentPage={paginationActivityValue.page}
                        totalPages={paginationActivityValue.totalPages}
                        onPageChange={getActivityData}
                      />
                    )}
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </Layout>

      <DeleteModal show={show} handleClose={handleClose} handleDelete={handleDelete} title={title}
        message={message} />
      <EventViewModal show={viewShow} handleClose={handleViewClose} selectedEvent={selectedEvent} />

      <AddSkillModal show={showAddSkill} setAddSkill={setAddSkill} getSkillData={getSkillData} skillData={selectedSkill} setSelectedSkill={setSelectedSkill} id={id} setId={setId} page={paginationSkillValue.page} />
      <AddActivityModal show={showActivity} setShowActivity={setShowActivity} getActivityData={getActivityData} activityData={selectedActivity} setSelectedActivity={setSelectedActivity} id={id} setId={setId} page={paginationActivityValue.page} />
      <AddCategoryModal show={showCat} setShowCat={setShowCat} getCategoryData={getCategoryData} categoryData={selectedCat} setSelectedCat={setSelectedCat} id={id} setId={setId} page={paginationCatValue.page} />

    </>
  )
}

export default EventManagement